import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const SUIVIPAIEMENT_URL = `${backendUrl}/api/suivipaiement/`;

class SuivipaiementService {
	async getAllSuivipaiements() {
		try {
			const response = await axios.get(SUIVIPAIEMENT_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getSuivipaiement(id) {
		return axios.get(`${SUIVIPAIEMENT_URL}${id}/`);
	}

	createSuivipaiement(data) {
		return axios.post(SUIVIPAIEMENT_URL, data);
	}

	updateSuivipaiement(id, data) {
		return axios.patch(`${SUIVIPAIEMENT_URL}${id}/`, data);
	}

	deleteSuivipaiement(id) {
		return axios.delete(`${SUIVIPAIEMENT_URL}${id}/`);
	}

	getSuivipaiementNames(personelIds) {
		return axios.get(`${SUIVIPAIEMENT_URL}?personelIds=${personelIds}`);
	}

	getSuivipaiementOptions() {
		return this.getAllSuivipaiements().then((Suivipaiements) => {
			const options = Suivipaiements.map((Suivipaiement) => ({
				value: Suivipaiement.id,
				label: Suivipaiement.eleve.toUpperCase()
			}));
			// options.unshift({value: null, label: 'Selectionner la salle de Suivipaiement'});
			return options;
		});
	}
}

export default new SuivipaiementService();
